import type { ButtonConfig } from '../../declare'
import { useMemo } from 'react'
import { EasyModal, EasyIcon, FormPage } from 'src/components'
import { $consts } from 'src/plugins'
import { getParamsFromQueryFormat } from 'src/components/root/helper'
import { getSingleRule } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const EditTreeModalBtn = (props: Props) => {
  const formData = useMemo(() => {
    const { __RECORD__: record, CUSTOM_PARAMS } = props.config
    if (!CUSTOM_PARAMS || !record.ID) return {}

    const customParams = getParamsFromQueryFormat(CUSTOM_PARAMS, { record }) ?? {
      [CUSTOM_PARAMS]: record.ID
    }
    const paramsKey = Object.keys(customParams)[0]

    return {
      fromWhere: {
        pageType: $consts['TABLE/FORM_TYPE_EDIT_PAGE'],
        locateType: $consts['TABLE/CONTROL_LOCATE_ROW'],
        data: customParams
      },
      filterGroup: { Rules: [getSingleRule(paramsKey, 1, customParams[paramsKey])] },
    }
  }, [props.config.__RECORD__, props.config.CUSTOM_PARAMS])

  const { LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{ title: FORM_CODE, width: WIDTH }}
      slot={
        <span>
          <EasyIcon type={ICON} defaultIcon='EditOutlined' className='fz-16' />
          <span title={LABEL} className='pd-l4'>{LABEL}</span>
        </span>
      }
    >
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default EditTreeModalBtn